import projection from '../generated/pwg5m8f1.json';
import { AcceptanceManifest } from '../types';

export const pwg5m8f1AcceptanceManifest = projection as AcceptanceManifest;
